/**
 * Storing Magic Variables
 */
export const RUCafeTitle = "RU Cafe";
export const RUCafePara =
  "Created a coffee and donuts ordering application made using Java and Android studio. Provides users a GUI to order menu items, stores menu items in an order and stores orders.";
export const RUCafeImg = "/imgGallery/Cafe.png";
export const RUCafechList = ["Java", "Android Studio", "XML", "MVC", "OOP"];

export const POWTitle = "Proof of Work CLI";
export const POWPara =
  "Designed and created a proof of work program in Python that creates a puzzle using the combination of byte data from any file merged with a random combination of symbols to create a SHA-256 hash with the specified number of leading bits. Also created a verifier to show that the proof of work was done.";
export const POWImg = "/imgGallery/CLI.png";
export const POWList = ["Python", "CLI", "Computer Security"];

export const GameInventoryTitle = "Game Inventory Application";
export const GameInventoryPara =
  "Game Inventory is a full-stack web app for searching video games, building personalized lists, and tracking play status and ratings. Built with React/TypeScript frontend and .NET/Entity Framework backend, it uses Twitch's IGDB API for game data. Features include user authentication with JWT, email verification, and game status tracking (completed, playing, planned). Guest users can browse without registration.";
export const GameInventoryImg = "/imgGallery/GameInventoryImg.png";
export const GameInventoryList = ["React", "TypeScript", "Material UI", ".NET", "Entity Framework Core", "SQL", "JWT Authentication", "IGDB API", "Azure", "Vercel"];

export const RUCafeLink ="https://github.com/Tsaleem123/RU_CAFE"
export const POWLink = "https://github.com/Tsaleem123/Proof_Of_Work"
export const GameInventoryLink = "https://gameinventory.app/"